/**
 * External dependencies
 */
import inherits from 'inherits';

export default class WebPlan {
    
    constructor(cscom) {
        if (!(this instanceof WebPlan)) {
            return new WebPlan(cscom);
        }
        this.cscom = cscom;
    }

    list(data) {
        return this.cscom.req.get('/customer-site-api/web-plans/list', null, data);
    }

}
